import { AggregationLevel } from '../types/Energy';
import { TIME_IN_MILLISECONDS } from './constants';
export const getDefaultAggregationInterval = (timeDelta) => {
    if (timeDelta <= TIME_IN_MILLISECONDS.ONE_DAY) {
        return AggregationLevel.values[AggregationLevel.ONE_MINUTE];
    }
    if (timeDelta >= TIME_IN_MILLISECONDS.FIFTEEN_DAYS) {
        return AggregationLevel.values[AggregationLevel.ONE_HOUR];
    }
    return AggregationLevel.values[AggregationLevel.FIFTEEN_MINUTE];
};
